import { Injectable, signal } from '@angular/core';

/**
 * App-wide drawer state. The dashboard header and the shared app navbar both
 * trigger the same drawer, so the open/closed flag has to live above any one
 * component. A signal lets templates react without manual subscriptions.
 *
 * Auto-close on route change is handled by `SidebarDrawerComponent` itself,
 * not the service, so the service stays a single-purpose state holder.
 */
@Injectable({ providedIn: 'root' })
export class SidebarService {
  private readonly _isOpen = signal(false);

  readonly isOpen = this._isOpen.asReadonly();

  open(): void {
    this._isOpen.set(true);
  }

  close(): void {
    this._isOpen.set(false);
  }

  toggle(): void {
    this._isOpen.update((v) => !v);
  }
}
